import * as actions from '../actions';

const authInterceptor = ({ dispatch }) => next => action => {
  if (action.error) {
    if (action.error.status === 401) {
      dispatch(actions.logout());
    }
  } else {
    next(action);
  }
};

export default authInterceptor;
